var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-template-management" },
    [
      _c("document-template-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "documentTemplateTreeGrid",
        staticStyle: { height: "100%" },
        attrs: { context: _vm.context },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          add: _vm.addHandle,
          refresh: _vm.refreshHandle
        }
      }),
      _c("document-template-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "documentTemplateWorkspace",
        staticStyle: { height: "100%" },
        attrs: { "parent-context": _vm.context },
        on: {
          add: _vm.addHandle,
          edit: _vm.editHandle,
          look: _vm.lookHandle,
          back: _vm.backToList,
          refresh: _vm.refreshHandle
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }